import { NgModule } from '@angular/core';

import { AppModule } from './app.module';
import { AppComponent } from './app.component';
import {TransferHttpCacheModule} from '@nguniversal/common';

@NgModule({
  imports: [
    AppModule,
    TransferHttpCacheModule,
  ],
  providers: [
  ],
  bootstrap: [AppComponent],
})
export class AppBrowserModule { }